module.exports = __webpack_public_path__ + "img/JM.7593350e.png";